import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * To be used as a base component for components that need to manage subscriptions
 * to observables (e.g., Subject<T>) by providing a Subject to tie into your observable
 * lifecycles via the `takeUntil` operator. For example:
 *
 * ```
 * obs$ = service
 *     .something$
 *     .pipe(
 *         map(...),
 *         tap(...),
 *         catchError(...),
 *         // takeUntil should be the last operator in your pipeline when catchError
 *         // does not force a completion.
 *         takeUntil(this.destroy$)
 *     );
 * ```
 *
 * Selector and css definitions are not provided or needed.
 * Template definition is required but empty and unused.
 */
@Component({
    template: ``,
    standalone: false,
})
export class DestroyRxComponent implements OnDestroy {
    protected readonly destroy$ = new Subject<void>();

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
